import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter, RouterFeatures, withComponentInputBinding, withHashLocation, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { provideNzIcons } from 'ng-zorro-antd/icon';

import { AlainProvideLang, provideAlain, en_US as delonLang } from '@delon/theme';
import { default as ngLang } from '@angular/common/locales/en';
import { en_US as zorroLang } from 'ng-zorro-antd/i18n';
import { enUS as dateLang } from 'date-fns/locale';
import { AlainConfig } from '@delon/util/config';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';
import { ICONS } from '../style-icons';
import { ICONS_AUTO } from '../style-icons-auto';
import {I18NService,provideStartup} from '@core'
import { AuthInterceptor, AuthService } from '@share';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';


const defaultLang: AlainProvideLang = {
  abbr: 'en',
  ng: ngLang,
  zorro: zorroLang,
  date: dateLang,
  delon: delonLang
};

const alainConfig: AlainConfig = {
  auth: { login_url: '/passport/login' }
};

const routerFeatures: RouterFeatures[] = [
  withHashLocation(),
  withComponentInputBinding(),
  withViewTransitions(),
  withInMemoryScrolling({ scrollPositionRestoration: 'top' })
];

const ngZorroConfig: NzConfig = {};

registerLocaleData(en);
const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key])

export const appConfig: ApplicationConfig = {

  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,...routerFeatures),
    provideNzIcons(icons),
    provideNzI18n(en_US),
    provideAlain({ config: alainConfig, defaultLang, i18nClass: I18NService, icons: [...ICONS_AUTO, ...ICONS] }),
    provideNzConfig(ngZorroConfig),
    provideAnimationsAsync(),
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    
    provideHttpClient(),
    provideStartup(),
    provideHttpClient(withInterceptors([AuthInterceptor])), // Register the AuthInterceptor globally
    AuthService,// Register AuthService to handle authentication 
    provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerWhenStable:30000'
          }),
    // provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    // provideMessaging(() => getMessaging()) ,
    importProvidersFrom([
      AngularFireModule.initializeApp(environment.firebaseConfig),
      AngularFireMessagingModule,
    ]),

    ],
};
